// Utilitário para converter arquivos HEIC/HEIF para JPEG
import heic2any from 'heic2any';

/**
 * Converte um arquivo HEIC/HEIF para JPEG
 * @param file Arquivo HEIC/HEIF original
 * @returns Promise com o arquivo JPEG convertido
 */
export async function converterHeicParaJpeg(file: File): Promise<File> {
  // Verificar se é HEIC/HEIF
  const isHeic = file.name.toLowerCase().endsWith('.heic') || 
                 file.name.toLowerCase().endsWith('.heif') ||
                 file.type === 'image/heic' || 
                 file.type === 'image/heif';

  if (!isHeic) {
    // Se não for HEIC, retornar o arquivo original
    return file;
  }

  try {
    // Converter HEIC para JPEG usando heic2any
    const convertedBlob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.9,
    });

    // heic2any pode retornar um array ou um único blob
    const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

    // Criar um novo arquivo com o nome convertido
    const fileName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
    const convertedFile = new File([blob], fileName, {
      type: 'image/jpeg',
      lastModified: Date.now(),
    });

    return convertedFile;
  } catch (error) {
    console.error('Erro ao converter HEIC para JPEG:', error);
    throw new Error('Erro ao converter arquivo HEIC. Por favor, converta o arquivo manualmente para JPEG antes de fazer upload.');
  }
}
